@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>School Profile</h4>
      <small>View school information and update configurable settings</small>
    </div>

  </section>

  <section class="school-container">
    <div class="box-one">
      <div class="school-details">
        <div class="heading">
          <div>
            <img [src]="school()?.payload?.school_img ?? '/auth/school-admin-logo.png'" alt="school logo">
          </div>
        </div>

        <h6>{{ school()?.payload?.school_name }}</h6>
      </div>

      <div class="school-colors">
        <h6>School Colors</h6>

        <div class="colors">
          <div></div>

          <div></div>

          <small>PRIMARY</small>
          <small>SECONDARY</small>
      </div>
      </div>

    </div>

    <div class="box-two">

      <div class="general-information">

        <div class="head">
          <h6>General Information</h6>
          <p class="description">Core school details</p>
        </div>

        <div class="form">
          <div class="Ti">
            <div>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_77_607)">
                  <path d="M1.62427 4.87286L6.49724 1.08276L11.3702 4.87286V10.8287C11.3702 11.1159 11.2561 11.3913 11.053 11.5944C10.85 11.7975 10.5745 11.9116 10.2873 11.9116H2.70715C2.41995 11.9116 2.14452 11.7975 1.94144 11.5944C1.73836 11.3913 1.62427 11.1159 1.62427 10.8287V4.87286Z" stroke="black" stroke-width="1.08288"/>
                  <path d="M4.87305 11.9117V6.49731H8.1217V11.9117" stroke="black" stroke-width="1.08288"/>
                </g>
                <defs>
                  <clipPath id="clip0_77_607">
                    <rect width="12.9946" height="12.9946" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="text">
              <p class="description">School Name</p>
              <p>{{ school()?.payload?.school_name ?? 'N/A' }}</p>
            </div>
          </div>

          <div class="green-check">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M7.49542 2.24854L3.3729 6.37106L1.49902 4.49718" stroke="#15803D" stroke-width="1.12432"/>
            </svg>
          </div>
        </div>

        <div class="form">
          <div class="Ti">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <g clip-path="url(#clip0_77_625)">
                  <path d="M2.16565 2.16577H10.8287C11.4243 2.16577 11.9116 2.65307 11.9116 3.24865V9.74595C11.9116 10.3415 11.4243 10.8288 10.8287 10.8288H2.16565C1.57006 10.8288 1.08276 10.3415 1.08276 9.74595V3.24865C1.08276 2.65307 1.57006 2.16577 2.16565 2.16577Z" stroke="black" stroke-width="1.08288"/>
                  <path d="M11.9116 3.24854L6.49718 7.03863L1.08276 3.24854" stroke="black" stroke-width="1.08288"/>
                </g>
                <defs>
                  <clipPath id="clip0_77_625">
                    <rect width="12.9946" height="12.9946" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="text">
              <p class="description">Phone</p>
              <p>{{ school()?.payload?.phone ?? 'N/A' }}</p>
            </div>
          </div>

          <div class="green-check">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M7.49542 2.24854L3.3729 6.37106L1.49902 4.49718" stroke="#15803D" stroke-width="1.12432"/>
            </svg>
          </div>
        </div>

        <div class="form">
          <div class="Ti">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <g clip-path="url(#clip0_77_643)">
                  <path d="M6.49718 11.9116C9.48748 11.9116 11.9116 9.48748 11.9116 6.49718C11.9116 3.50688 9.48748 1.08276 6.49718 1.08276C3.50688 1.08276 1.08276 3.50688 1.08276 6.49718C1.08276 9.48748 3.50688 11.9116 6.49718 11.9116Z" stroke="black" stroke-width="1.08288"/>
                  <path d="M1.08276 6.49731H11.9116" stroke="black" stroke-width="1.08288"/>
                  <path d="M6.49731 1.08276C7.85161 2.56542 8.62125 4.48953 8.66308 6.49718C8.62125 8.50483 7.85161 10.4289 6.49731 11.9116C5.14301 10.4289 4.37337 8.50483 4.33154 6.49718C4.37337 4.48953 5.14301 2.56542 6.49731 1.08276Z" stroke="black" stroke-width="1.08288"/>
                </g>
                <defs>
                  <clipPath id="clip0_77_643">
                    <rect width="12.9946" height="12.9946" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="text">
              <p class="description">Location</p>
              <p>{{ school()?.payload?.location ?? 'N/A' }}</p>
            </div>
          </div>

          <div class="green-check">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path d="M7.49542 2.24854L3.3729 6.37106L1.49902 4.49718" stroke="#15803D" stroke-width="1.12432"/>
            </svg>
          </div>
        </div>
      </div>

      <form class="general-information update-form" #updateForm="ngForm" (ngSubmit)="updateSchoolProfile(updateForm)">
        <div class="head">
          <h6>Edit School Profile</h6>
          <p class="description">Update the details of your school</p>
        </div>

        <div class="form-group">
          <label for="schoolLocation">School Location/Address</label>
          <input required [(ngModel)]="location" type="text" name="schoolLocation" id="schoolLocation">
          <img class="location-icon" src="/auth/location-icon.png" alt="location icon">
        </div>

        <div class="form-group">
          <label for="phone">Phone</label>
          <input placeholder="e.g. 020 586 1876" required [(ngModel)]="phone" type="text" name="phone" id="phone">
        </div>

        <div class="form-group">
          <label for="schoolImage">School Logo Asset</label>

          <div>
            <input (change)="onFileSelected($event, updateForm)" type="file" name="schoolImage" id="schoolImage" accept="image/*">
            @if (imagePreview) {
              <img class="image-uploaded" [src]="imagePreview" alt="image uploaded">
            } @else {
              <img src="/auth/upload-icon.png" alt="upload icon" class="upload-icon">
              <p>Drag & drop logo image here</p>
              <small>JPEG or PNG max 2MB (200x200px recommended)</small>
            }
          </div>
        </div>

        <div class="color-inputs">

          <label for="primaryColor">Primary Color</label>
          <label for="secondaryColor">Secondary Color</label>

          <div>
            <input required [(ngModel)]="primaryColor" type="color" name="primaryColor" id="primaryColor">

            <p>{{ primaryColor }}</p>
          </div>

          <div>
            <input required [(ngModel)]="secondaryColor" type="color" name="secondaryColor" id="secondaryColor">

            <p>{{ secondaryColor }}</p>
          </div>
        </div>

        <button [disabled]="updateForm.untouched || updateForm.invalid || !imagePreview" class="button">
          @if (isSubmitting()) {
            <app-loading-indicator />
          } @else {
            Update Profile
          }
        </button>
      </form>

    </div>

  </section>
}
